import { useNavigate } from 'react-router-dom'
import apiClient from '../../global/utils/apiClient'
import { useMetaStore } from '../../scoring/store/MetaStore'
import LoginView from '../views/LoginView'
function LoginController() {
  const setIsAdmin = useMetaStore((state) => state.setIsAdmin)
  const setErrorMsg = useMetaStore((state) => state.setErrorMsg)
  const navigate = useNavigate()

  const handleSuccess = (credentialResponse) => {
    console.log('Login Success:', credentialResponse)
    // In a real app, you'd send credentialResponse.credential to your backend for verification
    // For now, we'll just set isAdmin to true
    localStorage.setItem('g-oauth-token', credentialResponse.credential)

    // call the /gskapi/meta/validatelogin route to validate the credential
    apiClient.get('/gskapi/meta/validatelogin')
      .then((response) => {
        if (response.status === 200) {
          setIsAdmin(true)
          navigate('/admin')
        } else {
          setErrorMsg('You are not authorized to perform admin functions.')
          navigate('/error')
        }
      })
      .catch((error) => {
        console.error('Error validating login:', error)
        setErrorMsg('Error validating login. Please try again later.')
        navigate('/error')
      })
  }

  const handleError = () => {
    console.log('Login Failed')
  }

  return <LoginView onSuccess={handleSuccess} onError={handleError} />
}

export default LoginController
